/**
 * @desc 物流订单信息提交（草稿箱）
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.TransportDraftBoxMasterRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/transportDraftBoxMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
